// atoms/item/selected-partner-product-order-cart-items-state.ts
import { atom } from 'recoil';
import { ItemDetailLineDto } from '../../types/dto/item-detail-line-dto';

const CART_ITEMS_KEY = 'cartItems';

// localStorage에서 초기 데이터를 가져오는 함수
const getInitialCartItems = (): ItemDetailLineDto[] => {
  const savedCartItems = localStorage.getItem(CART_ITEMS_KEY);
  return savedCartItems ? JSON.parse(savedCartItems) : [];
};

export const selectedPartnerProductOrderCartItemsState = atom<ItemDetailLineDto[]>({
  key: 'selectedPartnerProductOrderCartItemsState',
  default: getInitialCartItems(),
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        localStorage.setItem(CART_ITEMS_KEY, JSON.stringify(newValue));
      });
    },
  ],
});